/**
 * POS · Reports — placeholder scaffold. The write-off / comp report and the
 * on-site pfand liability card are wired in the implement phase against the
 * existing reporting endpoints; this page reserves the route + IA slot so the
 * design pass can lay it out. Plain AntD.
 */

import { Card, Space, Typography } from "antd";

export const PosReportsPage = () => (
  <Space direction="vertical" size="large" style={{ width: "100%" }}>
    <Typography.Title level={3}>POS reports</Typography.Title>
    <Card title="Write-offs & comps (per POS)">
      <Typography.Paragraph type="secondary">
        Cost + potential revenue of comps/write-offs. To be wired against the
        reporting endpoints in the implement phase.
      </Typography.Paragraph>
    </Card>
    <Card title="On-site pfand liability">
      <Typography.Paragraph type="secondary">
        Outstanding on-site deposit (own block, per <code>pfand_value</code>
        breakdown) from <code>/api/dashboard/onsite-pfand-balance</code>.
      </Typography.Paragraph>
    </Card>
  </Space>
);
